import React, {useEffect, useState} from 'react'
import {Grid, Segment, Icon, Label, Form, List, Header, Button, Image, Modal, Table, Dimmer, Loader} from "semantic-ui-react";
import Axios from "axios";
import {
    DateInput,
    TimeInput
} from 'semantic-ui-calendar-react';
import objDefault from '../../../models/opnoteModel'
import moment from "moment";
import Constants from "../../../config/constants";
import FileBase64 from 'react-file-base64';
import {useHistory} from "react-router-dom";
import useStaff from "../../../hooks/useStaff";
import wireframe from '../../../images/image_wireframe.png'

const options = [
    {key: 'GA', text: 'GA', value: 'GA'},
    {key: 'RA', text: 'RA', value: 'RA'},
    {key: 'LA', text: 'LA', value: 'LA'},
    {key: 'SB', text: 'SB', value: 'SB'},
    {key: 'MAC', text: 'MAC', value: 'MAC'}
]

const options_surgical = [
    {key: 'clean', text: 'clean', value: 'clean'},
    {key: 'clean contaminated', text: 'clean contaminated', value: 'clean contaminated'},
    {key: 'Contaminated', text: 'Contaminated', value: 'Contaminated'},
    {key: 'Dirty', text: 'Dirty', value: 'Dirty'}
]


const Opnote = () => {
    const [input, setInput] = useState({
        ...objDefault
    });
    const [loading, setLoading] = useState(false);
    const [inputText, setInputText] = useState({
        text_head: 'เกิดข้อผิดพลาด',
        text_description: 'กรุณาติดต่อผู้ดูแลระบบ',
        text_error: [],
        date_input: false,
        department_input: false,
        intern_input: false,
        diagnosis_input: false,
        op_date_input: false,
        op_date_operation_input: false,
        op_time_start_input: false,
        op_time_end_input: false,
        surgeon_input: false,
        first_assistant_input: false,
        second_assistant_input: false,
        scrub_nurse_input: false,
        clinical_diagosis_input: false,
        post_operative_diagnosis_input: false,
        operative_procedure_input: false,
        anesthesia_input: false,
        anesthetist_input: false,
        surgical_w_classification_input: false,
    });
    const history = useHistory()
    const { staff: staffList } = useStaff();
    const [users, setUsers] = useState([]);
    const [op, setOps] = useState([]);
    const [open, setOpen] = React.useState(false)
    const [inputList, setInputList] = useState([]);

    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        console.log(name, value, e)

        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))

    };


    const addAssistant = () => {
        setInputList([...inputList, {assistant_name: ""}]);
    };

    const handleRemoveClick = (e, i) => {
        const list = [...inputList];
        list.splice(i, 1);
        setInputList(list);
    };

    const handleInputChange = (e, index) => {
        const {name, value} = e.target;
        const list = [...inputList];
        list[index][name] = value;
        setInputList(list);
    };
    const handleValidate = () => {
        setInputText((prevInput) => ({
            ...prevInput,
            first_assistant_input: !!!input.first_assistant ? 'require' : false,
            date_input: !!!input.date ? 'require' : false,
            department_input: !!!input.department ? 'require' : false,
            intern_input: !!!input.intern ? 'require' : false,
            diagnosis_input: !!!input.diagnosis ? 'require' : false,
            op_date_input: !!!input.op_date ? 'require' : false,
            op_date_operation_input: !!!input.op_date_operation ? 'require' : false,
            op_time_start_input: !!!input.op_time_start ? 'require' : false,
            op_time_end_input: !!!input.op_time_end ? 'require' : false,
            surgeon_input: !!!input.surgeon ? 'require' : false,
            scrub_nurse_input: !!!input.scrub_nurse ? 'require' : false,
            clinical_diagosis_input: !!!input.clinical_diagosis ? 'require' : false,
            post_operative_diagnosis_input: !!!input.post_operative_diagnosis ? 'require' : false,
            operative_procedure_input: !!!input.operative_procedure ? 'require' : false,
            surgical_w_classification_input: !!!input.surgical_w_classification ? 'require' : false,
        }))

    }

    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('admission_id')

        getOpnoteAdmissionId(id)
    }, []);

    const getOpnoteAdmissionId = async (id) => {
        setLoading(true);
        try {
            let op_data = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/opnote?admission_id=' + id,
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            );
            let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission?id=' + id,
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                });
            response = response.data.data[0]
            setOps(op_data.data.data)
            setInput((prevInput) => ({
                ...prevInput,
                patient_id: response.patient_id,
                diagnosis: response.primary_diagnosis,
                admission_id: id,
                ward: response.ward,
                resident: response.resident_name,
                staff_id: response.staff_id

            }))
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    function openInNewTab(id, path) {
        var win = window.open(path + id, '_blank');
        win.focus();
    }

    const navigateTo = (id, path) => {
        history.push(path + id);


    }


    const getFiles = (e, name) => {
        setInput((prevInput) => ({
            ...prevInput,
            [name]: e.base64
        }))
    }

    useEffect(() => {
        console.log(input.img_findings_1)
    }, [input])

    const getAssist = async (id) => {
        let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/opnoteAssistById?id=' + id,
            {
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });
        response = response.data.data
        setInputList(response)
    }
    const getOpnotById = async (e) => {
        setLoading(true);
        try {
            let response = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/opnoteById?id=' + e.op_note_id,
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                });
            await getAssist(e.op_note_id)
            response = response.data.data[0]
            setInput((prevInput) => ({
                ...prevInput,
                id: response.id,
                patient_id: response.patient_id,
                admission_id: response.admission_id,
                age: response.age,
                date: moment(response.date).format("DD-MM-YYYY"),
                department: response.department,
                intern: response.intern,
                // diagnosis: response.diagnosis,
                op_date_operation: moment(response.op_date_operation).format("DD-MM-YYYY"),
                op_time_start: response.op_time_start,
                op_time_end: response.op_time_end,
                surgeon: response.surgeon,
                first_assistant: response.first_assistant,
                second_assistant: response.second_assistant,
                scrub_nurse: response.scrub_nurse,
                clinical_diagosis: response.clinical_diagosis,
                post_operative_diagnosis: response.post_operative_diagnosis,
                operative_procedure: response.operative_procedure,
                anesthesia: (response.anesthesia).split(','),
                anesthetist: response.anesthetist,
                surgical_w_classification: (response.surgical_w_classification).split(','),
                position: response.position,
                incision: response.incision,
                findings_1: response.findings_1,
                findings_2: response.findings_2,
                findings_3: response.findings_3,
                findings_4: response.findings_4,
                findings_5: response.findings_5,
                img_findings_1: response.img_findings_1,
                img_findings_2: response.img_findings_2,
                img_findings_3: response.img_findings_3,
                img_findings_4: response.img_findings_4,
                img_findings_5: response.img_findings_5,
                img_findings_1_preview: response.img_findings_1,
                img_findings_2_preview: response.img_findings_2,
                img_findings_3_preview: response.img_findings_3,
                img_findings_4_preview: response.img_findings_4,
                img_findings_5_preview: response.img_findings_5,
                procedure: response.procedure,
                estimate_blood: response.estimate_blood,
                complication: response.complication,
                user_record: response.user_record,
                ward: response.ward,
                resident: response.resident,
                staff: response.staff
            }))

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }

    const navigateToBasket = (fullPath) => {
        history.push(fullPath);
    }

    const saveOpnote = async () => {
        setLoading(true);
        try {
            handleValidate()
            let result = await Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/opnote',
                {
                    id: input.id,
                    patient_id: input.patient_id,
                    admission_id: input.admission_id,
                    age: '',
                    date: input.date,
                    department: input.department,
                    intern: input.intern,
                    diagnosis: input.diagnosis,
                    op_date_operation: input.op_date_operation,
                    op_time_start: input.op_time_start,
                    op_time_end: input.op_time_end,
                    surgeon: input.surgeon,
                    first_assistant: input.first_assistant,
                    scrub_nurse: input.scrub_nurse,
                    clinical_diagosis: input.clinical_diagosis,
                    post_operative_diagnosis: input.post_operative_diagnosis,
                    operative_procedure: input.operative_procedure,
                    anesthesia: input.anesthesia,
                    anesthetist: input.anesthetist,
                    surgical_w_classification: input.surgical_w_classification,
                    position: input.position,
                    incision: input.incision,
                    findings_1: input.findings_1,
                    findings_2: input.findings_2,
                    findings_3: input.findings_3,
                    findings_4: input.findings_4,
                    findings_5: input.findings_5,
                    img_findings_1: input.img_findings_1,
                    img_findings_2: input.img_findings_2,
                    img_findings_3: input.img_findings_3,
                    img_findings_4: input.img_findings_4,
                    img_findings_5: input.img_findings_5,
                    procedure: input.procedure,
                    estimate_blood: input.estimate_blood,
                    complication: input.complication,
                    user_record: input.user_record,
                    ward: input.ward,
                    resident: input.resident,
                    staff: input.staff,
                    assistant_name: inputList
                }, {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (result.data.message === 'Missing require field') {
                setInputText((prevInput) => ({
                    ...prevInput,
                    text_head: 'เกิดข้อผิดพลาด',
                    text_description: result.data.message,
                    text_error: result.data.message_description
                }))
            } else {
                setInputText((prevInput) => ({
                    ...prevInput,
                    text_head: 'ทำรายการสำเร็จ',
                    text_description: result.data.data.message,
                    text_error: []
                }))

            }

            setOpen(true)
            if (input.admission_id) {
                await getOpnoteAdmissionId(input.admission_id)

            }
        } catch (e) {
            console.log(e)
            setInputText((prevInput) => ({
                ...prevInput,
                text_head: 'เกิดข้อผิดพลาด',
                text_description: 'กรุณาติดต่อผู้ดูแลระบบ'
            }))

            setOpen(true)

        } finally {
            setLoading(false);
        }

    }

    const softDeleteImg = async (id, img_name,position) => {

        if (window.confirm("ยืนยันลบรูปภาพ")) {
            setLoading(true);
            try {
                await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/list-delete-img?id=' + id+'&img_name='+img_name+'&position='+position,
                    {
                        headers: {
                            Authorization: Constants.headerAuthorization,
                            'Content-Type': 'application/json'
                        }
                    }
                )
                setInput((prevInput) => ({
                    ...prevInput,
                    [position]: null,
                }))
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }
    }


    return (
        <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>


            <div style={{flex: 1, position: 'relative'}}>
                <Dimmer active={loading} inverted>
                    <Loader size='large'>กำลังโหลดข้อมูล...</Loader>
                </Dimmer>
                <Grid style={{marginTop: "5em", marginLeft: "2em"}}>
                    {
                        input.admission_id ?
                            <>

                                <Grid.Row>
                                    <Grid.Column width={10}>
                                        <Segment color='teal' raised>
                                            <Header as='h3' dividing>

                                                <Button color='teal'
                                                        onClick={() => navigateTo(input.admission_id, '/admission?id=')}
                                                        key={input.admission_id}>
                                                    <Icon name={'file alternate outline'}></Icon> Admission note
                                                </Button>
                                                <Button color='teal'
                                                        onClick={() => navigateTo(input.admission_id, '/discharge?admission_id=')}
                                                        key={input.admission_id}>
                                                    <Icon name={'file alternate outline'}></Icon> Discharge summary

                                                </Button>
                                                <Button color='teal'
                                                        onClick={() => openInNewTab(input.admission_id, '/opnote?admission_id=')}
                                                        key={input.admission_id}>
                                                    <Icon name={'plus'}></Icon>new Operation note
                                                </Button>
                                                <Button color='teal'
                                                        onClick={() => navigateToBasket(`/basket?admission_id=${input.admission_id}&patient_id=${input.patient_id}`)}
                                                        key={input.admission_id}>
                                                    <Icon name={'image'}></Icon>Picture basket
                                                </Button>

                                            </Header>
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </>
                            : ''
                    }
                    <Grid.Row>

                        <Grid.Column width={3}>
                            <Segment color='teal' raised>
                                <Label>
                                    <Icon name='wordpress forms'/> รายการ operation note
                                </Label>


                                <List divided relaxed>
                                    {

                                        op.length > 0 ? op.map((user, index) => (

                                            <List.Item key={user.op_note_id}>
                                                # {index + 1} <label><Icon name='file pdf' color={"red"}
                                                                           style={{cursor: 'pointer'}}
                                                                           onClick={() => openInNewTab(user.op_note_id, '/opnote/pdf?id=')}/></label>
                                                <List.Icon name='user circle' size='large' verticalAlign='middle'/>
                                                <List.Content
                                                    onClick={(e) => getOpnotById(user)}
                                                >
                                                    <List.Header as='a'>{user.name} HN :{user.hn} surgeon
                                                        : {user.surgeon} </List.Header>
                                                    <List.Description as='a'>Clinical diagosis
                                                        : {user.clinical_diagosis}</List.Description>
                                                    <List.Description as='a'>Date of operation
                                                        : {moment(user.op_date_operation).format("DD-MM-YYYY")}</List.Description>
                                                    <List.Description as='a'>Time
                                                        : {user.op_time_start} - {user.op_time_end}</List.Description>
                                                </List.Content>
                                            </List.Item>
                                        )) : <List.Item> <List.Content><List.Header as='a'>ไม่พบข้อมูล operation
                                            note</List.Header></List.Content></List.Item>
                                    }
                                </List>

                            </Segment>
                        </Grid.Column>

                        <Grid.Column width={12}>

                            <Segment color='teal' raised>
                                <Form>
                                    <Header as='h3' color='blue' dividing>
                                        Basic information
                                    </Header>


                                    <Form.Group widths='equal'>

                                        <Form.Input
                                            name="diagnosis"
                                            placeholder="diagnosis"
                                            value={input.diagnosis}
                                            label='Diagnosis'
                                            onChange={(e) => handleValueChange(e)}
                                            required={true}
                                            disabled={true}

                                        />


                                    </Form.Group>


                                    <Form.Group widths='equal'>
                                        <DateInput
                                            name="op_date_operation"
                                            placeholder="Date"
                                            value={input.op_date_operation}
                                            label='Date of operation'
                                            iconPosition="right"
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={'true'}
                                            error={inputText.op_date_operation_input}
                                        />
                                        <TimeInput
                                            name="op_time_start"
                                            placeholder="Date"
                                            value={input.op_time_start}
                                            label='Time start'
                                            iconPosition="right"
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={'true'}
                                            error={inputText.op_time_start_input}
                                        />
                                        <TimeInput
                                            name="op_time_end"
                                            placeholder="Date"
                                            value={input.op_time_end}
                                            label='Time end'
                                            iconPosition="right"
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={'true'}
                                            error={inputText.op_time_end_input}
                                        />


                                    </Form.Group>

                                    <Form.Group widths='equal'>

                                        <Form.Input
                                            fluid label='First assistant'
                                            name='first_assistant'
                                            icon={<Icon name='plus' color={'teal'} onClick={(e) => addAssistant(e)}
                                                        inverted
                                                        circular link/>}
                                            value={input.first_assistant}
                                            placeholder='First assistant'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.first_assistant_input}
                                        />
                                    </Form.Group>
                                    {

                                        inputList.map((x, i) => {
                                            let a = i + 2;
                                            return (
                                                <Form.Group widths='equal' key={{a}}>
                                                    <Form.Input
                                                        fluid label={'#' + a + 'assistant'}
                                                        name='assistant_name'
                                                        icon={<Icon name='delete' color={'red'}
                                                                    onClick={(e) => handleRemoveClick(e, i)} inverted
                                                                    circular link/>}
                                                        value={x.assistant_name}
                                                        placeholder=' assistant'
                                                        onChange={(e, {name, value}) => handleInputChange({
                                                            target: {
                                                                name,
                                                                value
                                                            }
                                                        }, i)}


                                                    />
                                                </Form.Group>
                                            );
                                        })
                                    }

                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid label='Surgeon'
                                            name='surgeon'
                                            value={input.surgeon}
                                            placeholder='Surgeon'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.surgeon_input}
                                        />
                                        <Form.Input
                                            fluid label='Scrub nurse'
                                            name='scrub_nurse'
                                            value={input.scrub_nurse}
                                            placeholder='Scrub nurse'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.scrub_nurse_input}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid label='Clinical diagosis'
                                            name='clinical_diagosis'
                                            value={input.clinical_diagosis}
                                            placeholder='Clinical diagosis'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.clinical_diagosis_input}
                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid label='Post-operative diagnosis'
                                            name='post_operative_diagnosis'
                                            value={input.post_operative_diagnosis}
                                            placeholder='Post-operative diagnosis'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.post_operative_diagnosis_input}
                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid label='Operative procedure'
                                            name='operative_procedure'
                                            value={input.operative_procedure}
                                            placeholder='Operative procedure'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.operative_procedure_input}
                                        />

                                    </Form.Group>
                                    <Form.Group widths={'equal'}>
                                        <Form.Select width={6}
                                                     multiple
                                                     fluid label='Anesthesia'
                                                     name='anesthesia'
                                                     value={input.anesthesia}
                                                     placeholder='Anesthesia'
                                                     options={options}
                                                     onChange={(e, {name, value}) => handleValueChange({
                                                         target: {
                                                             name,
                                                             value
                                                         }
                                                     })}
                                        />
                                        <Form.Input
                                            width={10}
                                            fluid label='Anesthesiologist'
                                            name='anesthetist'
                                            value={input.anesthetist}
                                            placeholder='Anesthetist'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group widths={'equal'}>
                                        <Form.Select
                                            multiple
                                            fluid label='Surgical Wound Classification'
                                            name='surgical_w_classification'
                                            value={input.surgical_w_classification}
                                            placeholder='Surgical Wound Classification'
                                            options={options_surgical}
                                            required={true}
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            error={inputText.surgical_w_classification_input}
                                        />

                                    </Form.Group>


                                    <Header as='h3' color='blue' dividing>
                                        Description of Operation
                                    </Header>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid label='Position'
                                            name='position'
                                            rows={2}
                                            value={input.position}
                                            placeholder='Position'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid label='Incision'
                                            name='incision'
                                            rows={2}
                                            value={input.incision}
                                            placeholder='Incision'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid label='Procedure'
                                            name='procedure'
                                            rows={3}
                                            value={input.procedure}
                                            placeholder='Procedure'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid label='Estimate Blood loss (ml.)'
                                            name='estimate_blood'
                                            type={'number'}
                                            value={input.estimate_blood}
                                            placeholder='Estimate Blood loss'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                        <Form.Input
                                            fluid label='Immediate post-operative complication'
                                            name='complication'
                                            value={input.complication}
                                            placeholder='None'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Header as='h3' color='blue' dividing>
                                        Findings
                                    </Header>
                                    <Form.Group widths='equal'>
                                        &nbsp;&nbsp;&nbsp;
                                        {input.img_findings_1 ? <Image
                                                onClick={() => openInNewTab(input.img_findings_1_preview, 'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=')}
                                                src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_1_preview}
                                                size='small' style={{width: 80, cursor: 'pointer'}}/> :
                                            <Image src={wireframe}
                                                   size='small' style={{width: 80}}/>

                                        }

                                        {input.img_findings_1 ?<Icon
                                            name="delete"
                                            onClick={() => softDeleteImg(input.id,input.img_findings_1_preview,'img_findings_1')}
                                            style={{
                                                height: 30,
                                                marginLeft: 0,
                                                color: '#ff5252',
                                                cursor: 'pointer'
                                            }}></Icon> : null}

                                        &nbsp;&nbsp;&nbsp;&nbsp;

                                        <FileBase64
                                            onDone={(e) => getFiles(e, 'img_findings_1')}
                                            name='img_findings_1'

                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid
                                            name='findings_1'
                                            value={input.findings_1}
                                            placeholder='detail'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        &nbsp;&nbsp;&nbsp;
                                        {input.img_findings_2 ? <Image
                                                onClick={() => openInNewTab(input.img_findings_2_preview, 'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=')}
                                                src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_2_preview}
                                                size='small' style={{width: 80, cursor: 'pointer'}}/> :
                                            <Image src={wireframe}
                                                   size='small' style={{width: 80}}/>}
                                        {input.img_findings_2 ?<Icon
                                            name="delete"
                                            onClick={() => softDeleteImg(input.id,input.img_findings_2_preview,'img_findings_2')}
                                            style={{
                                                height: 30,
                                                marginLeft: 0,
                                                color: '#ff5252',
                                                cursor: 'pointer'
                                            }}></Icon> : null}
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <FileBase64
                                            onDone={(e) => getFiles(e, 'img_findings_2')}
                                            name='img_findings_2'

                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid
                                            name='findings_2'
                                            value={input.findings_2}
                                            placeholder='detail'
                                            onChange={(e) => handleValueChange(e)}
                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        &nbsp;&nbsp;&nbsp;
                                        {input.img_findings_3 ? <Image
                                                onClick={() => openInNewTab(input.img_findings_3_preview, 'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=')}
                                                src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_3_preview}
                                                size='small' style={{width: 80, cursor: 'pointer'}}/> :
                                            <Image src={wireframe}
                                                   size='small' style={{width: 80}}/>}

                                        {input.img_findings_3 ?<Icon
                                            name="delete"
                                            onClick={() => softDeleteImg(input.id,input.img_findings_3_preview,'img_findings_3')}
                                            style={{
                                                height: 30,
                                                marginLeft: 0,
                                                color: '#ff5252',
                                                cursor: 'pointer'
                                            }}></Icon> : null}
                                        &nbsp;&nbsp;&nbsp;&nbsp;

                                        <FileBase64
                                            onDone={(e) => getFiles(e, 'img_findings_3')}
                                            name='img_findings_3'

                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid
                                            name='findings_3'
                                            value={input.findings_3}
                                            placeholder='detail'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>

                                    <Form.Group widths='equal'>
                                        &nbsp;&nbsp;&nbsp;
                                        {input.img_findings_4 ? <Image
                                                onClick={() => openInNewTab(input.img_findings_4_preview, 'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=')}
                                                src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_4_preview}
                                                size='small' style={{width: 80, cursor: 'pointer'}}/> :
                                            <Image src={wireframe}
                                                   size='small' style={{width: 80}}/>}
                                        {input.img_findings_4 ?<Icon
                                            name="delete"
                                            onClick={() => softDeleteImg(input.id,input.img_findings_4_preview,'img_findings_4')}
                                            style={{
                                                height: 30,
                                                marginLeft: 0,
                                                color: '#ff5252',
                                                cursor: 'pointer'
                                            }}></Icon> : null}

                                        &nbsp;&nbsp;&nbsp;&nbsp;

                                        <FileBase64
                                            onDone={(e) => getFiles(e, 'img_findings_4')}
                                            name='img_findings_4'

                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid
                                            name='findings_4'
                                            value={input.findings_4}
                                            placeholder='detail'

                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        &nbsp;&nbsp;&nbsp;
                                        {input.img_findings_5 ? <Image
                                                onClick={() => openInNewTab(input.img_findings_5_preview, 'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=')}
                                                src={'http://' + Constants.url + ':' + Constants.port + '/v1/snr/static?pic=' + input.img_findings_5_preview}
                                                size='small' style={{width: 80, cursor: 'pointer'}}/> :
                                            <Image src={wireframe}
                                                   size='small' style={{width: 80}}/>}

                                        {input.img_findings_5 ?<Icon
                                            name="delete"
                                            onClick={() => softDeleteImg(input.id,input.img_findings_5_preview,'img_findings_5')}
                                            style={{
                                                height: 30,
                                                marginLeft: 0,
                                                color: '#ff5252',
                                                cursor: 'pointer'
                                            }}></Icon> : null}

                                        &nbsp;&nbsp;&nbsp;&nbsp;

                                        <FileBase64
                                            onDone={(e) => getFiles(e, 'img_findings_5')}
                                            name='img_findings_5'

                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid
                                            name='findings_5'
                                            value={input.findings_5}
                                            placeholder='detail'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Header as='h3' dividing color='blue'>
                                        Record information
                                    </Header>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            name="department"
                                            placeholder="department"
                                            value={input.department}
                                            label='Department '
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}

                                        />
                                        <Form.Input
                                            name="ward"
                                            placeholder="ward"
                                            value={input.ward}
                                            label='ward '
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            disabled={true}

                                        />
                                        <Form.Select

                                            fluid label='Staff'
                                            name='staff_id'
                                            value={input.staff_id}
                                            options={staffList}
                                            placeholder='Staff'
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={'true'}
                                            disabled={true}
                                        />
                                        <Form.Input
                                            name="resident"
                                            placeholder="Resident"
                                            value={input.resident}
                                            label='Resident'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            disabled={true}

                                        />
                                        <Form.Input
                                            name="date"
                                            placeholder="date"
                                            value={input.date}
                                            label='date'
                                            onChange={(e) => handleValueChange(e)}
                                            required={'true'}
                                            error={inputText.date_input}

                                        />
                                    </Form.Group>
                                    <Form.Button color='blue'
                                                 onClick={() => saveOpnote()}
                                    ><Icon name='plus'/> บันทึก Operation note</Form.Button>
                                </Form>

                            </Segment>


                        </Grid.Column>
                    </Grid.Row>

                </Grid>
            </div>

            <Modal
                centered={false}
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                style={{height: 'auto', left: 'auto'}}

            >
                <Modal.Header>{inputText.text_head}</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        {inputText.text_description}
                    </Modal.Description>
                    {
                        inputText.text_error.map((v, i) => (
                            <Modal.Description key={i}><b style={{color: 'red'}}>{v}</b></Modal.Description>
                        ))
                    }
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setOpen(false)}>OK</Button>
                </Modal.Actions>
            </Modal>

        </div>


    );
}

export default Opnote;
